import { fmtInt } from "@/lib/api";

export default function ProductionSummaryCard({ summary }) {
  if (!summary || summary.length === 0) return null;
  return (
    <div className="border border-black bg-white" data-testid="production-summary">
      <div className="border-b border-black p-4 flex justify-between">
        <div className="overline text-zinc-500">RESUMO DE PRODUÇÃO POR TIPO</div>
        <div className="text-xs text-zinc-500">Use na separação</div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-[1px] bg-zinc-200">
        {summary.map((s) => (
          <div key={s.type} className="bg-white p-4">
            <div className="overline text-zinc-500 mb-2">{s.type}</div>
            <div className="font-mono text-3xl font-semibold text-[#E60000]">{fmtInt(s.total_cups)}</div>
            <div className="text-xs text-zinc-500 mt-1">copos · {s.items.length} SKU{s.items.length > 1 ? "s" : ""}</div>
            {Object.keys(s.by_color).length > 0 && (
              <div className="mt-3 pt-3 border-t border-zinc-200 space-y-1">
                {Object.entries(s.by_color).map(([color, qty]) => (
                  <div key={color} className="flex justify-between text-xs">
                    <span>{color}</span>
                    <span className="font-mono font-bold">{qty}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
